export const toNumber = (value) =>
  Number.isFinite(Number(value)) ? Number(value) : 0;

export const SEGMENT_COLORS = {
  detratores: '#d52029',
  neutros: '#f6a726',
  promotores: '#66b44e',
};

// Zonas de NPS: crítica / aperfeiçoamento / qualidade / excelência
export const getZonaNps = (score) => {
  if (score <= 0) {
    return { labelId: 'labelNpsZonaCritica', color: '#d52029' };
  }
  if (score <= 50) {
    return { labelId: 'labelNpsZonaAperfeicoamento', color: '#f6a726' };
  }
  if (score <= 75) {
    return { labelId: 'labelNpsZonaQualidade', color: '#8ec63f' };
  }
  return { labelId: 'labelNpsZonaExcelencia', color: '#66b44e' };
};